module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/deco_gray02-4cb3563b5fc69955846ce7c4ce00b6f1.png";